<template>
  <div class="MainContent" ref="MainContent">
    <!-- <img alt="Vue logo" src="../assets/logo.png"> -->
    <div v-if="CargaLista" class="SeparadorMedio"></div>
    <div v-if="!MensajeError && Es1v1()" :class="ContSwords()">
      <!-- <div v-if="Jugando()" class="ContenedorAnimacionDetallePartida">
        <div class="FondoAnimacionDetallePartida"></div>
      </div> -->
      <img class="swords" src="../assets/swords.png" alt="swords">
      <div class="DetallePartida">
        <div v-if="CargaLista && GameType != ''">
          {{GameType}}
          <br>
        </div>
        <!-- {{this.DetallePartida()}}
        <br>
        {{this.DetalleJugadores()}}
        <br> -->
        {{this.NombreMapa()}}
        <br>
        {{this.NombreServer()}}
      </div>
      <div class="DivAuxRelative" v-if="MostrarTiempoPartida">
        <div class="pA TiempoDePartida">{{TiempoDePartida}} (x1.7)</div>
      </div>
    </div>

    <div v-if="!MensajeError && !Es1v1() && CargaLista" :class="ContSwordsTG()">
      <img class="swords" src="../assets/swords.png" alt="swords">
      <div class="DetallePartida">
        <div v-if="CargaLista && GameType != ''">
          {{GameType}}
          <br>
        </div>
        <!-- {{this.DetallePartida()}}
        <br>
        {{this.DetalleJugadores()}}
        <br> -->
        {{this.NombreMapa()}}
        <br>
        {{this.NombreServer()}}
        <hr style="margin: 10px 0px 0px 0px;">
        <div class="pR" style="display:block; text-align:center; font-size: 24px;">
          <div :class="ClaseDiferenciaElos(this.JugadoresTeam1._Promedios._Dif1v1)" style="width:50%; text-align: center;">
            {{Math.abs(this.JugadoresTeam1._Promedios._Dif1v1)}}
          </div>
          <div class="pA w100 aliCenter" style="font-size: 14px; top: 5px;">1v1</div>
          <div :class="ClaseDiferenciaElos(this.JugadoresTeam2._Promedios._Dif1v1)"  style="width:50%; text-align: center;">
            {{Math.abs(this.JugadoresTeam2._Promedios._Dif1v1)}}
          </div>
        </div>
        <div class="pR" style="display:block; text-align:center; font-size: 24px;">
          <div :class="ClaseDiferenciaElos(this.JugadoresTeam1._Promedios._DifTG)" style="width:50%; text-align: center;">
            {{Math.abs(this.JugadoresTeam1._Promedios._DifTG)}}
          </div>
          <div class="pA w100 aliCenter" style="font-size: 14px; top: 5px;">TG</div>
          <div :class="ClaseDiferenciaElos(this.JugadoresTeam2._Promedios._DifTG)" style="width:50%; text-align: center;">
            {{Math.abs(this.JugadoresTeam2._Promedios._DifTG)}}
          </div>
        </div>

        
        <div class="DivAuxRelative" v-if="MostrarTiempoPartida">
          <div class="pA TiempoDePartida">{{TiempoDePartida}} (x1.7)</div>
        </div>
      </div>
    </div>

      <!-- <img v-for="Civ in ListadoCivis" :key="Civ.id" :src="'https://aoe2.club/assets/images/civs/(' + Civ.id + ').png'" height="25px" width="25px" :alt="Civ.string"> -->
    <div v-if="CargaLista" class="SeccionI" ref="SeccionI">
      <!-- <div class="BarraColor1"></div> -->
      
      <div v-if="Es1v1()" class="Seccion1v1 Team1">
        <div class="ContenedorImagenUnidadUnica">
          <img class="ImagenPaisJugador1v1 l0" :src="UrlImagenPais(JugadoresTeam1[0], false)"
              :title="PaisJugador(JugadoresTeam1[0])" :alt="PaisJugador(JugadoresTeam1[0])">
          <img class="ImagenCiviJugador1v1 Team1" :src="LogoCiviUnidadUnica(JugadoresTeam1[0].civ)" :alt="Civi(JugadoresTeam1[0].civ)" 
            :title="Civi(JugadoresTeam1[0].civ)">
          <div class="SeccionDetalleJugador1v1">
            <div :class="'BarraColorJugador BarraColorJugadorc' + JugadoresTeam1[0].color"></div>
            <div class="w100 f30 Info1v1 t1">
              <div :class="ClaseNombreJugador1v1(JugadoresTeam1[0])">
                <span class="hP" @click="GoPerfil(JugadoresTeam1[0])">{{JugadoresTeam1[0].name}}</span>
              </div>
              <div class="Ajuste5">
                <div class="w100 aliRight f24 Ajuste3">
                  <div class="w1 aliCenter">AVG</div>
                  <div class="Separador"></div>
                  <div class="w1 aliCenter">MAX</div>
                  <div class="Separador"></div>
                  <div class="w1 aliCenter">NOW</div>
                  <div class="Separador"></div>
                  <div class="w1 aliCenter"></div>
                </div>
                <div class="w100 aliRight lH44 Ajuste4 pR">
                  <div class="w1 aliCenter">{{AvgRankingJugador(JugadoresTeam1[0])}}</div>
                  <div class="Separador"></div>
                  <div class="w1 aliCenter">{{MaxRankingJugador(JugadoresTeam1[0])}}</div>
                  <div class="Separador"></div>
                  <div class="w1 aliCenter B cCeleste">{{RankingJugador(JugadoresTeam1[0])}}</div>
                  <div class="Separador"></div>
                  <div class="w1 aliCenter"></div>
                  <div class="w1 aliCenter AjustePuesto1">{{RankJugador(JugadoresTeam1[0])}}</div>
                </div>
                <span class="ColorVerde">W-<b>{{PartidasGanadasJugador(JugadoresTeam1[0])}}</b></span> 
                <span class="ColorRojo"> L-<b>{{PartidasPerdidasJugador(JugadoresTeam1[0])}}</b></span>
                <span class=""><span class="c555"> | </span>{{PorcentajeVictorias(JugadoresTeam1[0])}}</span>
                <span class=""><span class="c555"> | </span>
                  <span class="ColorVerde B" v-if="StreakJugador(JugadoresTeam1[0]) > 0">&#8593;<b>{{StreakJugador(JugadoresTeam1[0])}}</b></span>
                  <span class="ColorRojo" v-if="StreakJugador(JugadoresTeam1[0]) < 0">&#8595;<b>{{StreakJugador(JugadoresTeam1[0])}}</b></span>
                </span>
              </div>
              <div class="aliRightFlex Ajuste1"><!-- Ultimas 5 civis usadas -->
                <div class="ContenedorUltimasCivisJugadas InvertirVertical">
                  <div v-if="!CargaUltimasCivisJugadas">
                    <Loading />
                  </div>
                  <div v-if="CargaUltimasCivisJugadas">
                    <div>
                      <img v-for="(Info, index) in JugadoresTeam1[0]._UltimasCivis" :key="index" :class="ClaseImagenCivi(Info, index)"
                          :src="LogoCivi(Info.Civi)" :alt="Civi(Info.Civi)" 
                          :title="Civi(Info.Civi)">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div v-if="CargaLista && !Es1v1()" class="ContenedorDatosTeam">
        <div v-for="Jugador in JugadoresTeam1" :key="Jugador.id" class="PanelJugador">
          <div v-if="Jugador.won" :class="'FondoGanador cg' + Jugador.color"></div>
          <div class="ContenedorBarraJugadorTeam">
            <div :class="'InvertirVertical BarraJugadorTeam Gradientc' + Jugador.color"></div>
          </div>
          <div class="DatosJugador Team1">
            <img class="ImagenPaisJugador" :src="UrlImagenPais(Jugador, true)"
            :title="PaisJugador(Jugador)" :alt="PaisJugador(Jugador)">
            <img class="ImagenCiviJugador" :src="LogoCivi(Jugador.civ)" :alt="Civi(Jugador.civ)" :title="Civi(Jugador.civ)">
            <div :class="ClaseNombreJugadorTG(Jugador)">
              {{Jugador.name}}
            </div>
            <span class="B mL10">({{RankingJugador(Jugador)}}-<span class="cPuntajeTG">{{RankingJugadorTG(Jugador)}}</span>)</span>
            <!-- <div :class="'CuadradoColor c' + Jugador.color">{{Jugador.color}}</div> -->
          </div>
          <div class="ContenedorBarraJugadorTeam">
            <div :class="'InvertirVertical BarraJugadorTeam1 Gradientc' + Jugador.color"></div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="CargaLista" class="SeccionD" ref="SeccionD">
      <!-- <div class="BarraColor2"></div> -->
      <div v-if="Es1v1()" class="Seccion1v1 Team2">
        <div class="ContenedorImagenUnidadUnica">
          <img class="ImagenPaisJugador1v1 r0" :src="UrlImagenPais(JugadoresTeam2[0], false)"
              :title="PaisJugador(JugadoresTeam2[0])" :alt="PaisJugador(JugadoresTeam2[0])">
          <img class="ImagenCiviJugador1v1 Team2" :src="LogoCiviUnidadUnica(JugadoresTeam2[0].civ)" :alt="Civi(JugadoresTeam2[0].civ)" 
            :title="Civi(JugadoresTeam2[0].civ)">
          <div class="SeccionDetalleJugador1v1">
            <div :class="'r0 BarraColorJugador BarraColorJugadorc' + JugadoresTeam2[0].color"></div>
            <div class="w100 f30 Info1v1 t2">
              <div :class="ClaseNombreJugador1v1(JugadoresTeam2[0])">
                <span class="hP" @click="GoPerfil(JugadoresTeam2[0])">{{JugadoresTeam2[0].name}}</span>
              </div>
              <div class="Ajuste5">
                <div class="w100 aliLeft f24 Ajuste3">
                  <div class="w1 aliCenter"></div>
                  <div class="Separador"></div>
                  <div class="w1 aliCenter">NOW</div>
                  <div class="Separador"></div>
                  <div class="w1 aliCenter">MAX</div>
                  <div class="Separador"></div>
                  <div class="w1 aliCenter">AVG</div>
                </div>
                <div class="w100 aliLeft lH44 Ajuste4 pR">
                  <div class="w1 aliCenter"></div>
                  <div class="w1 aliCenter AjustePuesto2">{{RankJugador(JugadoresTeam2[0])}}</div>
                  <div class="Separador"></div>
                  <div class="w1 aliCenter B cCeleste">{{RankingJugador(JugadoresTeam2[0])}}</div>
                  <div class="Separador"></div>
                  <div class="w1 aliCenter">{{MaxRankingJugador(JugadoresTeam2[0])}}</div>
                  <div class="Separador"></div>
                  <div class="w1 aliCenter">{{AvgRankingJugador(JugadoresTeam2[0])}}</div>
                </div>
                <span class="">
                  <span class="ColorVerde B" v-if="StreakJugador(JugadoresTeam2[0]) > 0">&#8593;<b>{{StreakJugador(JugadoresTeam2[0])}}</b></span>
                  <span class="ColorRojo" v-if="StreakJugador(JugadoresTeam2[0]) < 0">&#8595;<b>{{StreakJugador(JugadoresTeam2[0])}}</b></span>
                </span>
                <span class="c555"> | </span>
                <span class="">{{PorcentajeVictorias(JugadoresTeam2[0])}} <span class="c555"> | </span></span>
                <span class="ColorRojo"> L-<b>{{PartidasPerdidasJugador(JugadoresTeam2[0])}}</b></span>
                <span class="ColorVerde"> W-<b>{{PartidasGanadasJugador(JugadoresTeam2[0])}}</b></span> 
              </div>
              <div class="Ajuste2"><!-- Ultimas 5 civis usadas -->
                <div class="ContenedorUltimasCivisJugadas">
                  <div v-if="!CargaUltimasCivisJugadas">
                    <Loading />
                  </div>
                  <div v-if="CargaUltimasCivisJugadas" class="LastCivisContainer">
                    <div v-for="(Info, index) in JugadoresTeam2[0]._UltimasCivis" :key="index" class="">
                      <img :class="ClaseImagenCivi(Info, index)"
                          :src="LogoCivi(Info.Civi)" :alt="Civi(Info.Civi)" 
                          :title="Civi(Info.Civi)">
                      </div>
                  </div>
                </div>
              </div>
              <!-- <div class="loading" v-if="!CargaUltimasCivisJugadas"> -->
            </div>
          </div>
        </div>
      </div>

      <div v-if="!Es1v1() && CargaLista" class="ContenedorDatosTeam r0">
        <div v-for="Jugador in JugadoresTeam2" :key="Jugador.id" class="PanelJugador">
          <div v-if="Jugador.won" :class="'InvertirVertical FondoGanador cg' + Jugador.color"></div>
          <div class="ContenedorBarraJugadorTeam">
            <div :class="'BarraJugadorTeam Gradientc' + Jugador.color"></div>
          </div>
          <div class="DatosJugador Team2">
            <span class="B mR10">(<span class="cPuntajeTG">{{RankingJugadorTG(Jugador)}}</span>-{{RankingJugador(Jugador)}})</span>
            <div :class="ClaseNombreJugadorTG(Jugador)">
              {{Jugador.name}}
            </div>
            <img class="ImagenCiviJugador" :src="LogoCivi(Jugador.civ)" :alt="Civi(Jugador.civ)" :title="Civi(Jugador.civ)">
            <img class="ImagenPaisJugador" :src="UrlImagenPais(Jugador, true)"
            :title="PaisJugador(Jugador)" :alt="PaisJugador(Jugador)">
            <!-- <div :class="'CuadradoColor c' + Jugador.color">{{Jugador.color}}</div> -->
          </div>
          <div class="ContenedorBarraJugadorTeam">
            <div :class="'BarraJugadorTeam1 Gradientc' + Jugador.color"></div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="MensajeError" class="MensajeError">
      {{MensajeError}}
    </div>
    
    <div v-if="!CargaLista" class="ContenedorCargando">
      <Loading />
    </div>
    
    <MarcadorResultados v-if="VerMarcador" ref="MarcadorResultados" />
    <MarcadorResultadosFB v-if="VerMarcadorFB" ref="MarcadorResultadosFB" />
    <MarcadorResultadosFBAuth v-if="VerMarcadorFBAuth" ref="MarcadorResultadosFBAuth" />
    <!-- <Logs ref="Logs" /> -->
    <Pruebas />
  </div>
  
</template>

<script>
  import Loading from './Loading';
  import MarcadorResultados from './MarcadorResultados';
  // import MarcadorResultadosFB from './MarcadorResultadosFB';
  // import MarcadorResultadosFBAuth from './MarcadorResultadosFB-Auth';
  import Pruebas from './Pruebas';
  
  export default {
    components: {
      Loading,
      MarcadorResultados,
      MarcadorResultadosFB: () => import("./MarcadorResultadosFB"),
      MarcadorResultadosFBAuth: () => import("./MarcadorResultadosFB-Auth"),
      Logs: () => import("./Logs"),
      Pruebas
    },
    data(){
      return {
        TiempoDePartida: "",
        IdSteam: "76561198063149648",
        ProfileId: "",
        Solo1v1: false,
        InfoUltimoPartido: null,
        InfoUltimosPartidos: null,
        Civis: null,
        TiposMapa: null,
        CargaLista: false,
        CargaUltimasCivisJugadas: false,
        JugadoresTeam1: [],
        JugadoresTeam2: [],
        UltimoIdPartida: "",
        PartidaActualTerminada: false,
        GanadorRevelado: false,
        NombreJugador: null,
        VerMarcador: false,
        _ReseteoMarcador: false,
        VerMarcadorFB: false,
        VerMarcadorFBAuth: false,
        MarcadorActivo: false,
        MensajeError: "",
        Jugador1_Rating: null,//Jugador 1 - Solo para 1v1
        Jugador2_Rating: null, //Jugador 1 - Solo para 1v1
        MostrarTiempoPartida: false,
        GameType: "",
        leaderboard_id: 0
      }
    },
    async mounted() {
      //console.log("Write me on discord: Marty#1533. Regards! :)");
      console.log('%c For uses, check here: https://github.com/LucasJappert/overlay-aoe-de', 'background: #000; color: #405bfe; font-size:18px;');
      console.log('%c Enjoy it 😀 ', 'background: #000; color: #405bfe; font-size:18px;');
      
      this.IdSteam = this.$route.query.idsteam;
      this.ProfileId = this.$route.query.profileid;
      if(this.IdSteam == null && this.ProfileId == null){
          return;
      }

      if(this.$route.query.resetscore === null){ this._ReseteoMarcador = true; }
      if(this.$route.query.showscore === null){ this.VerMarcador = true; }
      if(this.$route.query.showscoreFB === null){ this.VerMarcadorFB = true; }
      if(this.$route.query.showscoreFBAuth === null){ this.VerMarcadorFBAuth = true; }
      if(this.$route.query.showtime === null){ this.MostrarTiempoPartida = true; }

      //Para poner fondo negro o transparente segun sea el caso
      if(this.$route.query.nobackground === null){ 
        const body = document.getElementsByTagName('body')[0];
        body.classList.add('BodyConScore');
      }
      
      if(this.$route.query.f == 1){
        this.Solo1v1 = true;
      }
      await this.SetearInfoAge();
      this.SetearInfoUltimosPartidos();
      //this.ImagenesCivis();
      
      this.SetearTiempoDePartida();
    },
    methods: {
      async SetearInfoUltimosPartidos(){
        var _This = this;
        try {
          let _URL = "";
          if(this.IdSteam != null){
            _URL = "https://aoe2.net/api/player/matches?game=aoe2de&count=12&steam_id=" + this.IdSteam;
          }else if(this.ProfileId != null){
            _URL = "https://aoe2.net/api/player/matches?game=aoe2de&count=12&profile_id=" + this.ProfileId;
          }
          const _Promesa = await fetch(_URL);
          const _Resultado = await _Promesa.json();
          //console.log(_Resultado);

          var _AuxUltimoPartido = null;
          //console.log(_Resultado.length);
          //let typeGame = [0, 13];
          for (let index = 0; index < _Resultado.length; index++) {
            const _Partido = _Resultado[index];
            // if(_Partido.num_players == 2 && _Partido.game_type == 0){
            //if(typeGame.includes(_Partido.game_type)){
              if(this.Solo1v1){
                if (_Partido.num_players == 2){// && 	_Partido.players[0].name == "UndeckedAttic68"){ // && 	
                  _AuxUltimoPartido = _Partido;
                  break;
                }
              }else{
                _AuxUltimoPartido = _Partido;
                break;
              }
            //}
          }
          

          if(_AuxUltimoPartido == null){
            if(this.Solo1v1){
              this.MensajeError = "No 1v1 founded in last 12 games!";
            }else{
              this.MensajeError = "No TG founded in last 12 games!";//No deberia pasar
            }
            console.log(this.MensajeError);
            setTimeout(() => { this.SetearInfoUltimosPartidos(); }, 10 * 1000);
            return;
          }

          let isTG = false;
          if(_AuxUltimoPartido.num_players > 2){
            isTG = true;
          }
          this.leaderboard_id = _AuxUltimoPartido.leaderboard_id;
          //leaderboard_id == 0 --> Unranked
          if(_AuxUltimoPartido.leaderboard_id == 0){
            if(isTG){
              this.leaderboard_id = 4;
            }else{
              this.leaderboard_id = 3;
            }
          }


          // if(_AuxUltimoPartido.game_type == 13){
          //   this.GameType = "Empire War";
          // }else{
          //   this.GameType = "Random Map";
          // }
          // this.leaderboard_id = _AuxUltimoPartido.leaderboard_id;
          // console.log(_AuxUltimoPartido);

          const _JP = _AuxUltimoPartido.players.find(J => (J.profile_id == this.ProfileId || (J.steam_id == this.IdSteam && J.steam_id != null)));
          if(_JP){
            this.IdSteam = _JP.steam_id;
            this.ProfileId = _JP.profile_id;
          }else{
            console.log("Player not found: " + this.ProfileId + "-" + this.IdSteam);
            return;
          }

          this.MensajeError = "";
          //Ordeno jugador a la izquierda
          if(_AuxUltimoPartido.num_players == 2){
            var _PlayersOrdenados = [];
            for (let i = 0; i < _AuxUltimoPartido.num_players; i++) {
              const _P = _AuxUltimoPartido.players[i];
              if(_P.profile_id == _This.ProfileId){
                _PlayersOrdenados[0] = _P;
                _This.ProfileId = _P.profile_id;
              }else{
                _PlayersOrdenados[1] = _P;
              }
            }
            _AuxUltimoPartido.players = _PlayersOrdenados;
          }
          this.InfoUltimoPartido = _AuxUltimoPartido;

          //Chequeo si se actualizo el rated 1v1 de alguno de los players
          var _HayCambios = await this.ChequearCambioRatingJugadores();
          if(_HayCambios == false){
            if(this.UltimoIdPartida == this.InfoUltimoPartido.match_id){
              if (this.PartidaActualTerminada == false && this.InfoUltimoPartido.finished != null){
                //Dejo seguir para que actualice info
              }else{
                if(this.GanadorRevelado == false && this.InfoUltimoPartido.players[0].won != null){
                //Dejo seguir para que actualice info
                }else{
                    setTimeout(() => { this.SetearInfoUltimosPartidos(); }, 10 * 1000);
                    return;
                }
              }
            }
          }

          this.CargaLista = false;
          this.CargaUltimasCivisJugadas = false;
          this.PartidaActualTerminada = false;
          this.GanadorRevelado = false;
          //console.log(this.InfoUltimoPartido);


          this.UltimoIdPartida = this.InfoUltimoPartido.match_id;
          this.PartidaActualTerminada = this.InfoUltimoPartido.finished != null;
          this.GanadorRevelado = this.InfoUltimoPartido.players[0].won != null;


          this.JugadoresTeam1 = [];
          this.JugadoresTeam2 = [];
          if(this.InfoUltimoPartido){
            let _CantidadRegistros = 1;
            if(this.InfoUltimoPartido.num_players == 2){
              _CantidadRegistros = 1000;
              console.log("max calculated respect to latest " + _CantidadRegistros + " matchs...");
              console.log("avg calculated respect to latest " + 50 + " matchs...");
            }
            //Primero averiguo la cantidad de equipos
            var _Equipos = {};
            for (let index = 0; index < this.InfoUltimoPartido.players.length; index++){
              const Jugador = this.InfoUltimoPartido.players[index];
              if (_Equipos.hasOwnProperty(Jugador.team)){
                _Equipos[Jugador.team] += 1;
              }else{
                _Equipos[Jugador.team] = 1;
              }
            }
            // console.log(this.InfoUltimoPartido);
            // console.log(_Equipos);
            //console.log(Object.keys(_Equipos).length);
            for (let index = 0; index < this.InfoUltimoPartido.players.length; index++) {
              const Jugador = this.InfoUltimoPartido.players[index];
              if (Object.keys(_Equipos).length == 2){
                if (Jugador.team == Object.keys(_Equipos)[0]){
                  this.JugadoresTeam1.push(Jugador);
                }else{
                  this.JugadoresTeam2.push(Jugador);
                }
              }else{
                if (index % 2 == 0){
                  this.JugadoresTeam1.push(Jugador);
                }else{
                  this.JugadoresTeam2.push(Jugador);
                }
              }

              //Averiguo el Nombre
              if(Jugador.profile_id == _This.ProfileId){
                this.NombreJugador = Jugador.name;
              }
              document.title = this.NombreJugador + " - Overlay AOE II Definitive Edition - Lucas Jappert";

              await this.SetearRatingHistory(Jugador, _CantidadRegistros);
              await this.SetearInfoExtraPlayer(Jugador);
            }
          }

          const JugadorPrincipal = this.JugadoresTeam1.find(J => (J.profile_id == this.ProfileId));
          if(!JugadorPrincipal){
            //console.log(this.JugadoresTeam1);
            //Invierto
            let _Aux = this.JugadoresTeam1;
            this.JugadoresTeam1 = this.JugadoresTeam2;
            this.JugadoresTeam2 = _Aux;
          }

          // console.log(this.JugadoresTeam1);
          // console.log(this.JugadoresTeam2);
          
             
          //Chequeo Reseteo Marcador
          //Chequeo Marcador
          this.IniciarMarcador();
          //Chequeo Reseteo Marcador


          this.AjustesAlto();

          // this.JugadoresTeam1.sort((Jugador) => Jugador.color); 
          this.JugadoresTeam1.sort((a, b) => a.color - b.color);
          this.JugadoresTeam2.sort((a, b) => a.color - b.color);

          this.JugadoresTeam1._Promedios = this.PromedioEloTeam(this.JugadoresTeam1);
          this.JugadoresTeam2._Promedios = this.PromedioEloTeam(this.JugadoresTeam2);
          this.JugadoresTeam1._Promedios._Dif1v1 = this.JugadoresTeam1._Promedios._1v1 - this.JugadoresTeam2._Promedios._1v1;
          this.JugadoresTeam1._Promedios._DifTG = this.JugadoresTeam1._Promedios._TG - this.JugadoresTeam2._Promedios._TG;
          this.JugadoresTeam2._Promedios._Dif1v1 = this.JugadoresTeam1._Promedios._Dif1v1 * -1;
          this.JugadoresTeam2._Promedios._DifTG = this.JugadoresTeam1._Promedios._DifTG * -1;

          this.CargaLista = true;
          // console.log(this.JugadoresTeam1._Promedios);
          // console.log(this.JugadoresTeam2._Promedios);

          const _JP1 = this.JugadoresTeam1.find(J => (J.profile_id == this.ProfileId));
          await this.IniciarLogs(_JP1);
          await this.LogGuardarPartido();

          
          if(this.InfoUltimoPartido.num_players == 2){
            setTimeout(() => {
              this.CompletarUltimasCivisPlayers();
            }, 10);
          }
        } catch (error) {
          console.log(error);
        }

        setTimeout(() => { this.SetearInfoUltimosPartidos(); }, 10 * 1000);
      },
      IniciarMarcador(){
        try {
          var _AuxMR = this.$parent.$refs.Overlay.$refs.MarcadorResultados;
          if(_AuxMR){
            if(this.VerMarcador && this.MarcadorActivo == false){
              _AuxMR.ArrancarMarcador(this.NombreJugador, this.ProfileId, this._ReseteoMarcador);
              this.MarcadorActivo = true;
              // _AuxMR.ChequearPartido(this.RankingJugador(this.JugadoresTeam1[0]), this.InfoUltimoPartido.players[0].name);
            }
          }
        } catch (error) {
          console.log(error);
        }
      },
      async IniciarLogs(_Jugador){
        try {
          var _Logs = this.$parent.$refs.Overlay.$refs.Logs;
          if(_Logs){
            await _Logs.IniciarLogs(_Jugador);
            // _AuxMR.ChequearPartido(this.RankingJugador(this.JugadoresTeam1[0]), this.InfoUltimoPartido.players[0].name);
          }
        } catch (error) {
          console.log(error);
        }
      },
      async LogGuardarPartido(){
        try {
          var _Logs = this.$parent.$refs.Overlay.$refs.Logs;
          if(_Logs){
            _Logs.GuardarNuevoPartidoAnalizado(this.InfoUltimoPartido, this.JugadoresTeam1, this.JugadoresTeam2);
            // _AuxMR.ChequearPartido(this.RankingJugador(this.JugadoresTeam1[0]), this.InfoUltimoPartido.players[0].name);
          }
        } catch (error) {
          console.log(error);
        }
      },
      async SetearInfoAge(){
        try {
          const _Promesa = await fetch("https://aoe2.net/api/strings?game=aoe2de&language=sp");
          const _Resultado = await _Promesa.json();

          let _Civis = require('../assets/Civis.json');
          
          this.Civis = _Civis.civ;
          this.TiposMapa = _Resultado.map_type;
        } catch (error) {
          console.log(error);
        }
      },
      async ChequearCambioRatingJugadores(){
        var _Retorno = false;
        try {
          if(this.InfoUltimoPartido.num_players == 2){
            let _URL = `https://aoe2.net/api/player/ratinghistory?game=aoe2de&leaderboard_id=${this.leaderboard_id}&profile_id=${this.InfoUltimoPartido.players[0].profile_id}&count=1`;
            const _Promesa = await fetch(_URL);
            const _Resultado = await _Promesa.json();
            if (_Resultado.length > 0){
              if(this.Jugador1_Rating != _Resultado[0].rating){
                _Retorno = true;
                console.log("Jugador1 cambio " + this.Jugador1_Rating + " ---> " + _Resultado[0].rating);
                this.Jugador1_Rating = _Resultado[0].rating;

                var _AuxMR = this.$parent.$refs.Overlay.$refs.MarcadorResultados;
                if(_AuxMR){
                  _AuxMR.ActualizarRatingOverlay(this.Jugador1_Rating);
                }
              }
            }

            if(_Retorno == false || this.Jugador2_Rating == null){
              let _URL1 = `https://aoe2.net/api/player/ratinghistory?game=aoe2de&leaderboard_id=${this.leaderboard_id}&profile_id=${this.InfoUltimoPartido.players[1].profile_id}&count=1`;
              const _P1 = await fetch(_URL1);
              const _R1 = await _P1.json();
              if (_R1.length > 0){
                if(this.Jugador2_Rating != _R1[0].rating){
                  _Retorno = true;
                  console.log("Jugador2 cambio " + this.Jugador2_Rating + " ---> " + _R1[0].rating);
                  this.Jugador2_Rating = _R1[0].rating;
                }
              }
            }
          }
        } catch (error) {
          console.log(error);
        }
        return _Retorno;
      },
      AuxLeader(){
          let auxLeader = this.leaderboard_id;
          if(this.leaderboard_id == 4){
            auxLeader = 3;
          }else if (this.leaderboard_id == 14){
            auxLeader = 13;
          }
          return auxLeader;
      },
      async SetearRatingHistory(_Jugador, _CantidadRegistros){
        try {
          if(_Jugador.profile_id){
            let _URL = "";
            _URL = `https://aoe2.net/api/player/ratinghistory?game=aoe2de&leaderboard_id=${this.AuxLeader()}&profile_id=${_Jugador.profile_id}&count=${_CantidadRegistros}`;
            const _Promesa = await fetch(_URL);
            const _Resultado = await _Promesa.json();
            _Jugador._RatingHistory = _Resultado;
            _Jugador._RatingPromedio = 0;
            _Jugador._RatingMaximo = 0;
            if(_Jugador._RatingHistory){
              if(_Jugador._RatingHistory.length > 0){
                  _Jugador._RatingMaximo = Math.max.apply(Math, _Jugador._RatingHistory.map(function(o) { return o.rating; }));
                  let _Aux = _Jugador._RatingHistory.slice(0, 50);
                  _Jugador._RatingPromedio = _Aux.reduce((a, {rating}) => a + rating, 0) / _Aux.length;
                  _Jugador._RatingPromedio = Math.round(_Jugador._RatingPromedio, 0);
              }
            }
          }else{
            _Jugador._RatingHistory = null;
          }
        } catch (error) {
          console.log(error);
        }
      },
      async SetearInfoExtraPlayer(_Jugador){
        try {
          if(_Jugador.profile_id != null){
            const _Promesa = await fetch(`https://aoe2.net/api/leaderboard?game=aoe2de&leaderboard_id=${this.leaderboard_id}&profile_id=${_Jugador.profile_id}`);
            const _Resultado = await _Promesa.json();
            _Jugador._InfoExtra = _Resultado.leaderboard[0];
          }
          else{
            _Jugador._InfoExtra = null;
          }
        } catch (error) {
          console.log(error);
        }
      },
      async CompletarUltimasCivisPlayers(){
        await this.AuxCivisPlayer(this.JugadoresTeam1[0]);
        await this.AuxCivisPlayer(this.JugadoresTeam2[0]);
        this.CargaUltimasCivisJugadas = true;
      },
      async AuxCivisPlayer(_Jugador){
        try {
          _Jugador._UltimasCivis = [];
          if(_Jugador.steam_id == null && _Jugador.profile_id == null){
            return;
          }
          let _URL = "https://aoe2.net/api/player/matches?game=aoe2de&profile_id=" + _Jugador.profile_id + "&count=30";
          const _Promesa = await fetch(_URL,
          {
            mode: 'cors'
          });
          const _Resultado = await _Promesa.json();
          //console.log(_Resultado);
          for (let index = 0; index < _Resultado.length; index++) {
            const _Partido = _Resultado[index];
            //console.log(_Partido.game_type);
            if(_Partido.num_players == 2){// && (_Partido.leaderboard_id == 3 || _Partido.leaderboard_id == 4)){
              _Partido.players.forEach(Jugador => {
                // if (Jugador.steam_id == _Jugador.steam_id && Jugador.civ){
                // console.log(Jugador);
                if (Jugador.profile_id == _Jugador.profile_id){
                  if(Jugador.civ != null){
                    _Jugador._UltimasCivis.push({
                      Civi: Jugador.civ,
                      GameType: _Partido.game_type,
                      Won: Jugador.won,
                    });
                    //_Jugador._UltimasCivis.push(Jugador.civ);
                  }
                }
              });
            }
            if(_Jugador._UltimasCivis.length > 5){
              break;
            }
          }
        } catch (e) {
          console.log(e);
        }
      },
      UrlSvgPais(_Pais){
        return "https://aoe2.net/webjars/flag-icon-css/3.5.0/flags/4x3/" + _Pais.toLowerCase() + ".svg";
      },
      DetallePartida(){
        if(this.InfoUltimoPartido){
          //const Mapa = this.TiposMapa.find(mapa => mapa.id == this.InfoUltimoPartido.map_type);
          return "R.M";
        }
        return "-";
      },
      NombreMapa(){
        if(this.InfoUltimoPartido){
          const Mapa = this.TiposMapa.find(mapa => mapa.id == this.InfoUltimoPartido.map_type);
          if (Mapa){
            return Mapa.string;
          }
          return "Unknown";
        }
        return "-";
      },
      NombreServer(){
        if(this.InfoUltimoPartido){
          return this.InfoUltimoPartido.server;
        }
        return "-";
      },
      DetalleJugadores(){
        if(this.InfoUltimoPartido){
          //const Mapa = this.TiposMapa.find(mapa => mapa.id == this.InfoUltimoPartido.map_type);
          const _Aux = this.InfoUltimoPartido.num_players/2;
          return _Aux + "v" + _Aux;
        }
        return "-";
      },
      Civi(_Id){
        if (this.Civis){
          if (this.Civis[_Id]){
            return this.Civis[_Id].string.toLowerCase();
          }
        }
        return "";
      },
      ListadoCivis(){
        if (this.Civis){
          return this.Civis;
        }
        return [];
      },
      LogoCivi(_IdCivi){
        if(_IdCivi != null){
          if (this.Civis[_IdCivi]){
            return require('../assets/' + this.Civis[_IdCivi].string + '.png')
          }
        }
        return require('../assets/error.png')
      },
      LogoCiviUnidadUnica(_IdCivi){
        try {
          if(_IdCivi != null){
            return require('../assets/' + this.Civi(_IdCivi) + '-DE.png')
          }
          return require('../assets/error.png')
        } catch (error) {
          console.error(error);
          return require('../assets/error.png')
        }
      },
      Es1v1(){
        if(this.CargaLista){
          if (this.JugadoresTeam1.length == 1){
            return true;
          }
        }
        return false;
      },
      ContSwords(){
        var _Retorno = "ContSwords";
        if (this.InfoUltimoPartido && !this.InfoUltimoPartido.finished){
          _Retorno += " Jugando";
        }
        return _Retorno;
      },
      Jugando(){
        if (this.InfoUltimoPartido && !this.InfoUltimoPartido.finished){
          return true;
        }
        return false;
      },
      ContSwordsTG(){
        var _Retorno = "ContSwords ContSwordsTG ";
        if (this.InfoUltimoPartido && !this.InfoUltimoPartido.finished){
          _Retorno += " Jugando";
        }
        return _Retorno;
      },
      ClaseNombreJugador1v1(_Jugador){
        // console.log("Jugador: " + _Jugador.color, _Jugador);
        var _Retorno = "B f32 lH55 Estilo1";
        if (this.InfoUltimoPartido && this.InfoUltimoPartido.finished){
          if(_Jugador.won == false){
            _Retorno += " Tachado";
          }
        }
        return _Retorno;
      },
      ClaseNombreJugadorTG(_Jugador){
        var _Retorno = "SeccionNombreJugador";
        if (this.InfoUltimoPartido && this.InfoUltimoPartido.finished){
          if(_Jugador.won == false){
            _Retorno += " Tachado";
          }
        }
        return _Retorno;
      },
      ClaseMarcadorResultados(){
        if(!this.NombreJugador){
          return "dNone";
        }
        return "";
      },
      ClaseImagenCivi(Info, index){
        var _Retorno = "ImagenUltimaCiviUsada i" + index;
        if (Info.GameType == 13){
          _Retorno += " DistincionImagenEW";
        }
        if (Info.Won === null) {
          _Retorno += "";
        }
        else if (Info.Won === true) {
          _Retorno += " CivWon";
        }
        else if (Info.Won === false) {
          _Retorno += " CivLose";
        }
        return _Retorno;
      },
      RankJugador(_Jugador){
        if(_Jugador._InfoExtra){
          return "#" + _Jugador._InfoExtra.rank;
        }
        return "#"
      },
      RankingJugador(_Jugador){
        if(_Jugador._RatingHistory){
          if(_Jugador._RatingHistory[0]){
            //console.log(_Jugador.name, _Jugador);
            return _Jugador._RatingHistory[0].rating;
          }
        }
        return 0;
      },
      MaxRankingJugador(_Jugador){
        if(_Jugador._RatingMaximo){
          return _Jugador._RatingMaximo;
        }
        return 0;
      },
      AvgRankingJugador(_Jugador){
        if(_Jugador._RatingPromedio){
          return _Jugador._RatingPromedio;
        }
        return 0;
      },
      RankingJugadorTG(_Jugador){
        // let _Player = this.InfoUltimoPartido.players.find(element => (element.name == _Jugador.name));
        // if (_Player){
        //   if(_Player.name == "TM Marty"){
        //     console.log(_Player);
        //     console.log(_Jugador);
        //   }
        //   return _Player.rating;
        // }
        if(_Jugador._InfoExtra){
          return _Jugador._InfoExtra.rating;
        }
        return 0;
      },
      PorcentajeVictorias(_Jugador){
        if(_Jugador._RatingHistory){
          if(_Jugador._RatingHistory[0]){
            var _CantidadPartidas = _Jugador._RatingHistory[0].num_wins + _Jugador._RatingHistory[0].num_losses;
            return (Math.round(_Jugador._RatingHistory[0].num_wins * 100 / _CantidadPartidas, 0) + "%");
          }
        }
        return "0%"
      },
      PartidasGanadasJugador(_Jugador){
        if(_Jugador._RatingHistory){
          if(_Jugador._RatingHistory[0]){
            return _Jugador._RatingHistory[0].num_wins;
          }
        }
        return "0"
      },
      PartidasPerdidasJugador(_Jugador){
        if(_Jugador._RatingHistory){
          if(_Jugador._RatingHistory[0]){
            return _Jugador._RatingHistory[0].num_losses;
          }
        }
        return "0"
      },
      StreakJugador(_Jugador){
        if(_Jugador._RatingHistory){
          if(_Jugador._RatingHistory[0]){
            return _Jugador._RatingHistory[0].streak;
          }
        }
        return " - "
      },
      UrlImagenPais(_Jugador, _TG){
        var _Pais = this.PaisJugador(_Jugador);
        if(_Pais != ""){
          if(_TG){
            return "https://aoe2.net/webjars/flag-icon-css/3.5.0/flags/1x1/" + _Pais + ".svg";
          }else{
            return "https://aoe2.net/webjars/flag-icon-css/3.5.0/flags/4x3/" + _Pais + ".svg";
          }
        }else{
          return require('../assets/error.png')
        }
      },
      PaisJugador(_Jugador){
        if(_Jugador && _Jugador.country){
          return _Jugador.country.toLowerCase();
        }
        return "";
      },
      GoPerfil(_Jugador){
        // this.$router.push("./?idsteam=" + _Jugador.steam_id);
        // location.reload();

        // let routeData = this.$router.resolve({name: 'routeName', query: {data: "someData"}});
        // window.open(routeData.href, '_blank');
        let route;
        route = this.$router.resolve({path: "./?profileid=" + _Jugador.profile_id});
        // if (_Jugador.steam_id != null){
        //   route = this.$router.resolve({path: "./?idsteam=" + _Jugador.steam_id});
        // }else{
        //   route = this.$router.resolve({path: "./?profileid=" + _Jugador.profile_id});
        // }

        // let route = this.$router.resolve('/link/to/page'); // This also works.
        window.open(route.href, '_blank');
      },
      PromedioEloTeam(_Team){
        var _Retorno = {
            _1v1: 0,
            _TG: 0,
            _Dif1v1: 0,
            _DifTG: 0,
        };
        try {
          if(_Team.length > 0){
            var _Puntaje1v1 = 0;
            var _PuntajeTG = 0;
            _Team.forEach(_Jugador => {
              _Puntaje1v1 += this.RankingJugador(_Jugador);
              _PuntajeTG += this.RankingJugadorTG(_Jugador);
            });
            _Retorno._1v1 = Math.round(_Puntaje1v1 / _Team.length, 0);
            _Retorno._TG = Math.round(_PuntajeTG / _Team.length, 0);
          }
        } catch (e) {
          console.log(e);
        }
        return _Retorno;
      },
      ClaseDiferenciaElos(_Valor){
        var _Retorno = "dIB vAliMiddle";
        if (_Valor > 0){
          _Retorno += " ColorVerde";
        }else{
          _Retorno += " ColorRojo";
        }
        return _Retorno;
      },
      SetearTiempoDePartida(){
        try {
          // console.log(this.InfoUltimoPartido.finished);
          // console.log(this.InfoUltimoPartido.started);
          // console.log(new Date().getTime()/1000);

          if (!this.InfoUltimoPartido){
              setTimeout(() => {
              this.SetearTiempoDePartida();
            }, 1000);
            return;
          }

          var _Retorno = "";
          var _DuracionEnSegundos = 0;
          if(this.InfoUltimoPartido.finished){
            _DuracionEnSegundos = Math.round((this.InfoUltimoPartido.finished - this.InfoUltimoPartido.started), 0);
          }else{
            _DuracionEnSegundos = Math.round(((new Date().getTime() / 1000) - this.InfoUltimoPartido.started), 0);
          }
          //_DuracionEnSegundos = _DuracionEnSegundos * 1.7;
          _DuracionEnSegundos = _DuracionEnSegundos * 1.7;

          _Retorno = new Date(_DuracionEnSegundos * 1000).toISOString().substr(11, 8);
          var _Horas = _Retorno.substr(0, 2);
          if (_Horas == "00"){
            _Retorno = _Retorno.slice(-5);
          }

          //console.log(_Retorno);

          this.TiempoDePartida = _Retorno;
          if(!this.InfoUltimoPartido.finished){
            // setTimeout(() => {
            //   this.SetearTiempoDePartida();
            // }, (1000/1.7));
            setTimeout(() => {
              this.SetearTiempoDePartida();
            }, 1000);
          }
        } catch (e) {
          console.log(e);
        }
      },
      AjustesAlto(){
        try {
          //console.log(this.JugadoresTeam1.length);
          let heightBox = 280;
          if (this.JugadoresTeam1.length == 2){
            heightBox *= (1/2);
          }
          else if (this.JugadoresTeam1.length == 3){
            heightBox *= (3/4);
          }
          //console.log(this.$refs.MainContent.style.height);
          // console.log(this.$refs.SeccionD);
          // console.log(this.$refs.SeccionI.style);
          this.$refs.MainContent.style.height = `${heightBox}px`;
          // this.$refs.SeccionD.style.height = `${heightBox}px`;
          // this.$refs.SeccionI.style.height = `${heightBox}px`;
        } catch (error) {
          console.error(error);
        }
      }
    }
  }

  
</script>

<style lang="scss" scoped>
  $c1: #405BFE;
  $c2: #FF0000;
  $c3: #00FF00;
  $c4: #FFFF00;
  $c5: #00FFFF;
  $c6: #FF57B3;
  $c7: #797979;
  $c8: #FF9600;
  $Ancho: 1280px;
  $Alto: 280px;
  
  .MainContent{
    position:relative;
    width: $Ancho;
    height: $Alto;
    background-color: #444;
    background-image: url("../assets/hex.png");
    background-repeat: repeat;
    font-family: "Lato", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
    color:#DDD;
    display: flex;
    align-items: flex-start;
    box-shadow:inset 0 0 20px #000;
    // border:4px solid #000;
    box-sizing:border-box;
    // background-size: ;
  }
  .BordeAnimado{
    --border-width: 3px;
    width: $Ancho;
    height: $Alto;
    border-radius: var(--border-width);

    &::after {
      position: absolute;
      content: "";
      top: calc(-1 * var(--border-width));
      left: calc(-1 * var(--border-width));
      z-index: -1;
      width: calc(100% + var(--border-width) * 2);
      height: calc(100% + var(--border-width) * 2);
      background: linear-gradient(
        60deg,
        hsl(224, 85%, 66%),
        hsl(269, 85%, 66%),
        hsl(314, 85%, 66%),
        hsl(359, 85%, 66%),
        hsl(44, 85%, 66%),
        hsl(89, 85%, 66%),
        hsl(134, 85%, 66%),
        hsl(179, 85%, 66%)
      );
      background-size: 300% 300%;
      background-position: 0 50%;
      border-radius: calc(2 * var(--border-width));
      animation: moveGradient 4s alternate infinite;
    }
  }
  /*Begin moveGradient code*/
  @keyframes moveGradient {
    50% {
      background-position: 100% 50%;
    }
  }
  .SeparadorMedio{
    position:absolute;
    // left: calc(#{$Ancho} * 0.5 - 1px);
    height:100%;
    width:2px;
    background-color: #FFF;
    left: 50%;
    transform: translate(-50%, 0);
  }
  $AnchoContSwords: 180px;
  .ContSwords{
    position:absolute;
    //left: calc(#{$Ancho} * 0.5 - #{$AnchoContSwords} * 0.5); 
    bottom: 0px;
    height:134px;
    width:$AnchoContSwords;
    background-color: #000;
    border:2px solid #FFF;
    // box-shadow:inset 0 0 20px #000;
    z-index:11;
    height: fit-content;
    padding:3px 0px;
    border-radius: 20px 20px 0 0;
    left: 50%;
    transform: translate(-50%, 0);
    //opacity:1;
  }
  .ContSwords.Jugando, .ContSwordsTG.Jugando{
    animation: AnimacionDetallePartida 1s ease-in-out infinite alternate-reverse ;
  }
  @keyframes AnimacionDetallePartida {
    from {
      //opacity: 0;
      // border:2px solid #000;
      // box-shadow: 0 0 0px #0A0;
      // border:2px solid #000;
      background-color: rgba(50, 50, 50, 1);
    }
    to {
      // opacity: 1;
      // border:2px solid #000;
      // box-shadow:0 0 30px #0A0;
      // border:2px solid #0F0;
      background-color: rgba(0, 0, 0, 1);
    }
  }
  .ContSwordsTG{
    border-radius: 20px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .swords{
    // width: calc(#{$AnchoContSwords} - 20px);
    width: 50px;
    display:none;
  }
  .SeccionD, .SeccionI{
    width:calc(#{$Ancho} * 0.5);
    position:relative;
    height: 100%;
  }
  // .SeccionI > .ContenedorDatosTeam{left:8px;}
  .BarraColor1{
    width: calc(#{$Ancho} * 0.5);
    height:10px;
    background-color: red;
    display:block;
  }
  .BarraColor2{
    width: calc(#{$Ancho} * 0.5);
    height:10px;
    background-color: blue;
    display:block;
  }
  .PanelJugador{
    font-size:30px;
    display:block;
    padding:3px 0;
    line-height: 62px;
    border-top: 1px solid black;
    border-bottom: 1px solid black;
  }
  .DatosJugador{
    display:flex;
    align-items: stretch;
  }
  .DatosJugador.Team1{
    padding-right: calc(#{$AnchoContSwords} * 0.5 - 20px);
    justify-content: flex-start;
    // text-align: left;
  }
  .DatosJugador.Team2{
    padding-left: calc(#{$AnchoContSwords} * 0.5 - 20px);
    justify-content: flex-end;
  }
  .ContenedorBarraJugadorTeam{
    width:100%; height:0px; position:relative; display:block;
  }
  .BarraJugadorTeam{
    position:absolute;
    width:100%; 
    height:2px;
    top: -3px;
  }
  .BarraJugadorTeam1{
    position:absolute;
    width:100%; 
    height:2px;
    bottom:-3px;
  }
  .ContenedorDatosTeam{
    position:absolute;
    // margin-top:2px;
    // width: calc(1280px * 0.5 - 8px);
    width: calc(1280px * 0.5 - 8px);
    // height: 268px;
    top: 0px;
    z-index:1;
    top: 50%;
    transform: translate(0, -50%);
  }
  $AuxCuadrado: 50px;
  .ImagenCiviJugador{
    width: $AuxCuadrado;
    height: $AuxCuadrado;
    margin:5px 2px;
  }
  .ImagenPaisJugador{
    width: calc(#{$AuxCuadrado} - 10px);
    height: calc(#{$AuxCuadrado} - 10px);
    margin:10px 7px;
    border-radius:5px;
  }
  .CuadradoColor{
    font-size:24px;
    width: calc(#{$AuxCuadrado} - 5px);
    height: calc(#{$AuxCuadrado} - 5px);
    text-align:center;
    line-height: 38px;
    box-sizing: border-box;
    border:1px solid #000;
    color: #000;
    font-weight: bold;
    box-shadow: inset 0 0 5px #000;
    margin:5px 2px;
    border-radius: 30px;
  }
  .c1{ background-color: $c1;}
  .c2{ background-color: $c2;}
  .c3{ background-color: $c3;}
  .c4{ background-color: $c4;}
  .c5{ background-color: $c5;}
  .c6{ background-color: $c6;}
  .c7{ background-color: $c7;}
  .c8{ background-color: $c8;}
  .SeccionNombreJugador{
    white-space: nowrap;
    margin:0 5px;
    max-width: 250px;
    overflow: hidden;
    height: 60px;
    text-overflow: ellipsis;
    // font-weight: bold;
  }

  .Seccion1v1{
    position:absolute;
    width: calc(#{$Ancho} * 0.5 - 6px);
    height: 100%;
    top:0px;
    z-index:1;
  }
  .Seccion1v1.Team1{
    left: 0px;
  }
  .Seccion1v1.Team2{
    right: 0px;
  }
  .ContenedorImagenUnidadUnica{
    position:relative;
    width: calc(#{$Ancho} * 0.5 - 6px);
    height: 100%;
  }
  .ImagenCiviJugador1v1{
    height: $Alto - 125px;
    position:absolute;
    bottom: 0px;
  }
  .ImagenCiviJugador1v1.Team1{
    left: 0px;
  }
  .ImagenCiviJugador1v1.Team2{
    right: 0px;
    -webkit-transform: scaleX(-1);
    transform: scaleX(-1);
  }
  .DetallePartida{
    font-size: 29px;
    line-height:27px;
  }
  .BarraColorJugador{
    // background-color: rgba(0,0,0,0); /* For browsers that do not support gradients */
    // background-image: linear-gradient(to right, #{$c1} , rgba(0,0,0,0));
    bottom:0px;
    position:absolute;
    width: calc(#{$Ancho} * 0.5 - 5px);
    height:10px;
  }
  .BarraColorJugadorc1{
    background-color: rgba(0,0,0,0);
    background-image: linear-gradient(to right, #{$c1}, rgba(0,0,0,0));
    -webkit-transform: scaleX(-1);
    transform: scaleX(-1);
  }
  .BarraColorJugadorc2{
    background-color: rgba(0,0,0,0);
    background-image: linear-gradient(to left, rgba(0,0,0,0), #{$c2});
  }
  .BarraColorJugadorc3{
    background-color: rgba(0,0,0,0);
    background-image: linear-gradient(to right, #{$c3}, rgba(0,0,0,0));
    -webkit-transform: scaleX(-1);
    transform: scaleX(-1);
  }
  .BarraColorJugadorc4{
    background-image: linear-gradient(to left, rgba(0,0,0,0), #{$c4});
  }
  .BarraColorJugadorc5{
    background-image: linear-gradient(to right, #{$c5}, rgba(0,0,0,0));
    -webkit-transform: scaleX(-1);
    transform: scaleX(-1);
  }
  .BarraColorJugadorc6{
    background-image: linear-gradient(to left, rgba(0,0,0,0), #{$c6});
  }
  .BarraColorJugadorc7{
    background-image: linear-gradient(to right, #{$c7}, rgba(0,0,0,0));
    -webkit-transform: scaleX(-1);
    transform: scaleX(-1);
  }
  .BarraColorJugadorc8{
    background-image: linear-gradient(to left, rgba(0,0,0,0), #{$c8});
  }
  .SeccionDetalleJugador1v1{
    height:100%; position:relative;
  }
  .Gradientc1{
    background-image: linear-gradient(to right, rgba(0,0,0,0), #{$c1});
  }
  .Gradientc2{
    background-image: linear-gradient(to right, rgba(0,0,0,0), #{$c2});
  }
  .Gradientc3{
    background-image: linear-gradient(to right, rgba(0,0,0,0), #{$c3});
  }
  .Gradientc4{
    background-image: linear-gradient(to right, rgba(0,0,0,0), #{$c4});
  }
  .Gradientc5{
    background-image: linear-gradient(to right, rgba(0,0,0,0), #{$c5});
  }
  .Gradientc6{
    background-image: linear-gradient(to right, rgba(0,0,0,0), #{$c6});
  }
  .Gradientc7{
    background-image: linear-gradient(to right, rgba(0,0,0,0), #{$c7});
  }
  .Gradientc8{
    background-image: linear-gradient(to right, rgba(0,0,0,0), #{$c8});
  }
  .r0{right:0;}
  .l0{left:0;}
  .ImagenPaisJugador1v1{
    position:absolute;
    width:70px;
  }
  .Info1v1{
    box-sizing: border-box;
    // padding: 0 calc(#{$AnchoContSwords} * 0.5 + 10px);
    padding: 0 5px;
    line-height:41px;
    // display:flex;
  }
  .Info1v1.t1{
    // align-items: flex-end;
    text-align: right;
    padding-right: 30px;
    padding-left: 80px;
  }
  .Info1v1.t2{
    // align-items: flex-start;
    text-align: left;
    padding-left: 33px;
    padding-right: 80px;
  }
  .Ajuste1{
    // width: calc(#{$Ancho} * 0.5 - 50px);
    margin-top:10px;
    padding-right:55px;
  }
  .Ajuste2{
    // width: calc(#{$Ancho} * 0.5 - 50px);
    margin-top:10px;
    padding-left:55px;
  }
  .ContenedorUltimasCivisJugadas{
    width:fit-content;
  }
  $AuxCivUsada: 70px;
  .ImagenUltimaCiviUsada{
    margin:0 3px;
    line-height:70px;
  }
  .ImagenUltimaCiviUsada.i0{
    height: #{$AuxCivUsada};
  }
  .ImagenUltimaCiviUsada.i1{
    height: calc(#{$AuxCivUsada} - 4px);
  }
  .ImagenUltimaCiviUsada.i2{
    height: calc(#{$AuxCivUsada} - 8px);
  }
  .ImagenUltimaCiviUsada.i3{
    height: calc(#{$AuxCivUsada} - 12px);
  }
  .ImagenUltimaCiviUsada.i4{
    height: calc(#{$AuxCivUsada} - 16px);
  }
  .ImagenUltimaCiviUsada.i5{
    height: calc(#{$AuxCivUsada} - 20px);
  }
  .DistincionImagenEW{
    border-bottom:2px solid #999;
    padding-bottom:5px;
  }
  .Estilo1{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 60px;
  }
  .MensajeError{
    position: absolute;
    width: 1000px;
    left: calc(50% - 500px);
    text-align:center;
    font-size:38px;
    line-height:38px;
    background-color: rgba(0,0,0,1);
    box-shadow: 0 0 10px #000;
    border-radius: 10px;
    top: 100px;
    padding:10px 0;
    border: 2px solid #FFF;
    box-sizing: border-box;
  }
  .ContenedorCargando{
    position: absolute;
    width: fit-content;
    left: 50%;
    transform: translate(-50%, -50%);
    // left: calc(50% - 500px);
    text-align:center;
    font-size:38px;
    line-height:78px;
    // box-shadow: 0 0 10px #000;
    border-radius: 10px;
    top: 100px;
    padding:10px 0;
    // border: 2px solid #FFF;
    box-sizing: border-box;
  }
  .w1{
    width:23%;
    display:inline-block;
  }
  .w2{
    width:50%;
    display:inline-block;
  }
  .Separador{
    width:1px;
    background-color: #555;
    display:inline-block;
    height: 44px;
  }
  .Ajuste3{
    line-height:24px;
    height:24px;
  }
  .Ajuste3 .Separador{
    height: 24px;
  }
  .Ajuste4{
    line-height:44px;
    height:44px;
    font-size:44px;
    margin-top: -8px;
    margin-bottom: 5px;
  }
  .Ajuste5{
    margin-top:10px;
  }
  .AjustePuesto1{
    position:absolute;
    top: -10px;
    right: -16px;
  }
  .AjustePuesto2{
    position:absolute;
    top: -10px;
    left: -16px;
  }
  .cPuntajeTG{
    color:#00bfff;
  }

  .FondoGanador {
    position: absolute;
    width: 100%;
    height: 60px;
    // background-color: black;
    //background-image: url(http://frontend.lostboys.nl/presenations/Icons-fonts/img/chrome.png);
    overflow: hidden;
  }
  .FondoGanador:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0);
    // background: linear-gradient(
    //   90deg,
    //   rgba(250, 250, 250, 0) 0%,
    //   rgba(250, 0, 0, 0.5) 50%,
    //   rgba(250, 250, 250, 0) 100%
    // );
    animation: AnimacionGanador 5s ease-in-out infinite;
  }
  .FondoGanador.cg1:after{
    //background-image: linear-gradient(to right, rgba(0,0,0,0), #{$c5});
    background: linear-gradient(
      90deg,
      rgba(250, 250, 250, 0) 0%, #{$c1} 50%, rgba(250, 250, 250, 0) 100%
    );
  }
  .FondoGanador.cg2:after{
    background: linear-gradient(
      90deg,
      rgba(250, 250, 250, 0) 0%, #{$c2} 50%, rgba(250, 250, 250, 0) 100%
    );
  }
  .FondoGanador.cg3:after{
    background: linear-gradient(
      90deg,
      rgba(250, 250, 250, 0) 0%, #{$c3} 50%, rgba(250, 250, 250, 0) 100%
    );
  }
  .FondoGanador.cg4:after{
    background: linear-gradient(
      90deg,
      rgba(250, 250, 250, 0) 0%, #{$c4} 50%, rgba(250, 250, 250, 0) 100%
    );
  }
  .FondoGanador.cg5:after{
    background: linear-gradient(
      90deg,
      rgba(250, 250, 250, 0) 0%, #{$c5} 50%, rgba(250, 250, 250, 0) 100%
    );
  }
  .FondoGanador.cg6:after{
    background: linear-gradient(
      90deg,
      rgba(250, 250, 250, 0) 0%, #{$c6} 50%, rgba(250, 250, 250, 0) 100%
    );
  }
  .FondoGanador.cg7:after{
    background: linear-gradient(
      90deg,
      rgba(250, 250, 250, 0) 0%, #{$c7} 50%, rgba(250, 250, 250, 0) 100%
    );
  }
  .FondoGanador.cg8:after{
    background: linear-gradient(
      90deg,
      rgba(250, 250, 250, 0) 0%, #{$c8} 50%, rgba(250, 250, 250, 0) 100%
    );
  }
  @keyframes AnimacionGanador {
    from {
      left: -150%;
    }
    to {
      left: 250%;
    }
  }
  .FondoAnimacionDetallePartida:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0);
    background: linear-gradient(
      90deg,
      rgba(250, 250, 250, 0) 0%,
      rgba(250, 0, 0, 0.5) 50%,
      rgba(250, 250, 250, 0) 100%
    );
    animation: AnimacionDetallePartida 5s ease-in-out infinite;
  }
  .TiempoDePartida{
    top: 20px;
    position: absolute;
    width: 100%;
    font-size: 30px;
  }
  .CivWon{
    -webkit-filter: drop-shadow(0px 0px 10px #3F3 );
    filter: drop-shadow(0 0 10px #3F3);
  }
  .CivLose{
    -webkit-filter: drop-shadow(0px 0px 10px #F00 );
    filter: drop-shadow(0px 0px 10px #F00);
  }
  .LastCivisContainer {
    display: flex;
    align-items: flex-start;
    justify-items: flex-start;
    position:relative;
  }
</style>
